export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq4-Report-PDF-Pg2.942b7a82.png";